var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmpty = function SvgEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#D4D7DB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M20.293 8v2.585M14 8.5l1.292 2.239M26.585 8.5l-1.293 2.239"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D4D7DB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7,
    d: "M6.8 22.57h8.048c.02 1 .647 2.997 2.996 2.997h5.288c.744-.294 2.232-1.305 2.232-2.997h7.93m-26.494 0v8.93h26.495v-8.93m-26.495 0 5.699-5.17H27.42l5.875 5.17"
  })));
};
export default SvgEmpty;